"use strict";
export default [
  {
    path: "/panel/admin/dashboard",
    component: () => import("@/packages/admin/layout/Admin.layout.vue"),
    redirect: { name: "admin.main" },
    meta: {
      title: "پنل ادمین",
      requiresAdmin: true,
    },
    children: [
      {
        path: "/panel/admin/dashboard/index",
        name: "admin.main",
        component: () => import("@/packages/admin/views/Certificates.vue"),
        meta: {
          title: "پنل ادمین",
          requiresAdmin: true,
        },
      },
      {
        path: "/panel/admin/users",
        name: "admin.users",
        component: () => import("@/packages/admin/views/Users.vue"),
        meta: {
          title: "کاربران",
          requiresAdmin: true,
        },
      },
    ],
  },
];
